import { createFileRoute } from '@tanstack/react-router'
import { CreateMedicationPage } from '_/features/pets/ui/pages/create-medication-page'

const CreateMedicationRoute = () => {
	const { petId } = Route.useParams()
	return <CreateMedicationPage petId={petId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/medications/create')({
	staticData: { title: 'medications_create_title' },
	component: CreateMedicationRoute,
})
